<template>
  <b-container fluid class="userView">
    <b-alert :show="showMessage" :variant="variantMessage" fade dismissible @dismised="showMessage = false">
      {{messageText}}
    </b-alert>
    <el-steps :active="active" finish-status="success">
      <el-step title="Tipo de usuario y permisos"></el-step>
      <el-step title="Información personal"></el-step>
      <el-step title="Finalizar"></el-step>
    </el-steps>
    <div id="steps">
      <role-selector
        v-if="active === 0"
        ref="roleSelector"
        :user="selectedUser"
        :state="state"
        @emitUpdateUser="emitUpdateUser"
        @emitAllSellersToggle="emitAllSellersToggle"
      />
      <user-form
        v-if="active === 1"
        ref="userForm"
        :state="state"
        :user="selectedUser"
        @update:uniqueEmail="isUniqueEmail = $event">
      </user-form>
      <resume-user-information 
        v-if="active === 2"
        ref="resumeUserInformation"
        :state="state"
        :user="selectedUser">
      </resume-user-information>
    </div>
    <b-button class="mr-2" @click="$router.push({ name: 'Usuarios' })">Cancelar</b-button>
    <b-button class="mr-2" v-show="active > 0 && active < 3" @click="previousStep">Atrás</b-button>
    <b-button variant="success" v-show="active < 2" :disabled="nextStepDisabled" @click="nextStep">Siguiente</b-button>
    <b-button :disabled="saveClicked" variant="success" v-show="active === 2" @click="handleSave">Finalizar</b-button>
    <b-button class="float-right" variant="primary" v-if="$route.params.id" @click="handleResetPassword()">Reiniciar clave</b-button>
  </b-container>
</template>
<script>
import UserForm from '@/components/user/UserForm.vue'
import RoleSelector from '@/components/user/RoleSelector.vue'
import ResumeUserInformation from '@/components/user/ResumeUserInformation.vue'
import { AdminServiceMixin, RoleService } from '@/mixims/AdminServiceMixin.js'
import { ValidationsMixim } from '@/mixims/ValidationsMixim'
export default {
  components: { UserForm, RoleSelector, ResumeUserInformation },
  mixins: [ AdminServiceMixin, ValidationsMixim, RoleService ],
  data () {
    return {
      allOrganizations: {},
      active: 0,
      isUniqueEmail: true,
      selectedUser: {
        organizations: this.$store.getters.isAdmin ? [] : this.$store.state.user_data.organizations,
        roles: [],
        firstName: null,
        lastName: null,
        email: null,
        id: null,
        userType: null,
      },
      saveClicked: false,
      messageText: '',
      showMessage: false,
      variantMessage: 'success',
      isLoadingRol: true,
      isLoadingUser: true,
      roleOptions: [],
      allSellers: false,
    }
  },
  computed: {
    state() {
      const isAdminUser = this.selectedUser.userType === 'ADMIN_USER';
      const isCatalogerUser = this.selectedUser.userType === 'CATALOGER_USER';
      const isLogisticsAdmin = this.selectedUser.userType === 'LOGISTICS_ADMIN';
      const isSellerAdmin = this.selectedUser.userType === 'ORGANIZATION_ADMIN_USER';
      const isSeller = this.selectedUser.userType === 'ORGANIZATION_STANDARD_USER';
      const noUser = !this.isLoadingUser && !this.selectedUser
      const atLeastOneSeller = this.selectedUser.organizations?.length > 0
      const sellerValidations = {
        adminOrCataloger: (isAdminUser || isCatalogerUser),
        logistic: (isLogisticsAdmin && (this.allSellers || (!this.allSellers && atLeastOneSeller))),
        sellerAdmin: (isSellerAdmin && atLeastOneSeller),
        seller: (isSeller && atLeastOneSeller)
      }

      return {
        firstName: noUser || this.isValidText(this.selectedUser.firstName, true, 20),
        lastName:  noUser || this.isValidText(this.selectedUser.lastName, true, 20),
        email:     noUser || (Boolean(this.selectedUser.email) && this.validateEmail(this.selectedUser.email, true) && this.isUniqueEmail),
        sellers:   noUser || Object.values(sellerValidations).includes(true),
        userType:  noUser || this.selectedUser.userType !== null
      }
    },
    nextStepDisabled () {
      if (this.active === 0) {
        return !(this.state.userType && this.state.sellers)
      }
      if (this.active === 1 && this.state.userType) {
        return !(this.state.firstName && this.state.lastName && this.state.email)
      }
      return Object.values(this.state).includes(false)
    }
  },
  methods: {
    nextStep () {
      if (this.active++ > 2) this.active = 0
    },
    previousStep () {
      if (this.active-- < 0) this.active = 0
    },
    emitUpdateUser (updatedUser) {
      this.selectedUser = updatedUser
    },
    emitAllSellersToggle (allSellers) {
      this.allSellers = allSellers
    },
    handleSave () { 
      this.active++
      let action = this.selectedUser.id ? this.updateUser : this.createUser
      let userToSave = { ...this.selectedUser }
      userToSave.roles = userToSave.roles.map(role => {
        return {
          id: role.id,
          roleName: role.roleName,
          description: role.description
        }
      })
      userToSave.roles.unshift({
        id: userToSave.userType,
        roleName: userToSave.userType
      })
      try {
        action(userToSave).then(() => {
          this.messageText = `Usuario ${userToSave.id ? 'actualizado' : 'creado'} de manera exitosa`
          this.showMessage = true
          this.variantMessage = 'success'
          setTimeout(() => this.$router.push({ name: 'Usuarios' }), 2000)
        }).catch(er => {
          if (er.body && er.body.message === 'Sellers is required') this.messageText = 'Debes seleccionar una organización/seller para este tipo de usuario' 
          else this.messageText = er.body.message || `Ocurrio un error ${userToSave.id ? 'actualizando' : 'creando'} el usuario`
          this.showMessage = true
          this.variantMessage = 'danger'
          this.saveClicked = false
          this.active--
        })
      } catch (e) {
        console.log(e.message)
        this.messageText = 'Ha ocurrido un error en el módulo de Administración'
        this.showMessage = true
        this.variantMessage = 'danger'
        this.saveClicked = false
        this.active--
      }
    },
    handleResetPassword () {
      try {
        this.resetPassword(this.selectedUser.id).then(() => {
          this.messageText = 'Contraseña reseteada de manera exitosa'
          this.showMessage = true
          this.variantMessage = 'success'
          if (this.active < 2) setTimeout(() => this.$router.push({ name: 'Usuarios' }), 2000)
        }).catch(er => {
          this.messageText = er.body.message || 'Ocurrió un error al reestablecer una contraseña'
          this.showMessage = true
          this.variantMessage = 'danger'
        })
      } catch (e) {
        console.log(e.message)
        this.messageText = 'Ha ocurrido un error en el módulo de Administración'
        this.showMessage = true
        this.variantMessage = 'danger'
      }
    },
    _getUser(userId) {
      this.isLoadingUser = true
      this.getUser(userId)
      .then(response => {
        this.selectedUser = response.body
        const userTypeRole = this.selectedUser.roles.find(role =>  ['LOGISTICS_ADMIN', 'ORGANIZATION_ADMIN_USER', 'ORGANIZATION_STANDARD_USER', 'CATALOGER_USER', 'ADMIN_USER'].includes(role.id))
        this.selectedUser.userType = userTypeRole ? userTypeRole.id : null

        if (userTypeRole) {
          this.selectedUser.roles = this.selectedUser.roles.filter(role => role.id !== userTypeRole.id)
        }

        if (this.selectedUser.userType === 'LOGISTICS_ADMIN' &&  this.selectedUser.organizations.length > 50) {
          this.allSellers = true
        }

        this.isLoadingUser = false
      })
      .catch(error => {
        this.isLoadingUser = false
      })
    }
  },
  mounted () {
    const userId = this.$route.params.id
    if (userId) this._getUser(userId)
  }
}
</script>
<style lang="scss" scoped>
.userView {
  #steps {
    margin-top: 20px;
    height: auto;
  }
}
</style>